module.exports = __webpack_public_path__ + "media/img/pages/profile/migros ger 1-50107e6ea7815ab52032f07f84a34af1.jpg";